const locale: any = {
  prelaunch: {
    title: 'A better way to find a doctor near you',
    subtitle:
      'Avoid long waiting time, get in touch with a doctor in seconds, book an appointment.',
    beta_welcome_disclaimer:
      'We are currently in beta! In the meantime you can explore the ins and outs of the app live in our <0><0>Discord channel</0></0>, where ideas meet and dreams take flight!',
    enter_email: 'Enter your email',
    accept_disclaimer:
      'I agree to the <0><0>Privacy Policy</0></0> and <1><0>Terms of Service</0></1>',
    accept_disclaimer_label:
      'I agree to the Privacy Policy and Terms of Service',
    early_access_button: 'Get an early invitation',
    beta_disclaimer:
      'We are currently in beta! Sign up to receive an invitation',
    success_title: 'Thank you! You are awesome!',
    success_first_text:
      'Thank you again for your interest in <0>{{name}}</0>! As soocomplete_appointmentn as the app is out of beta with the early adopters and ready for the official launch, you will be notified by email.',
    success_second_text:
      'In the meantime you can explore the ins and outs of the app live in our <0><0>Discord channel</0></0>, where ideas meet and dreams take flight!',
    already_account: 'Do you already have an account? <0><0>Log in</0></0>',
  },
  beta: {
    wip_page_message:
      'This function is currently under development. In the meantime if you need help please send us a message in our <0><0>Discord channel!</0></0>',
  },
  footer: {
    all_rights_reserved: 'All Rights Reserved',
    privacy_policy: 'Privacy Policy',
    terms_of_service: 'Terms of Service',
    cookie_policy: 'Cookies Policy and Consent',
    company_info:
      '{{service_name}} © {{start_year}} - {{current_year}} {{company_name}}, {{company_address}}. C.F. {{company_cf}} VAT ID: {{company_vat}}',
  },
  header: {
    anywhere_label: 'Anywhere',
    anyday_label: 'Any Day',
    selected_area_label: 'Selected Area',
  },
  meta: {
    partner_page_title_tail: 'Book an appointment',
  },
  navbar: {
    join_team: 'Add me to the list',
    usermenu_dashboard_label: 'Dashboard',
    usermenu_home_label: 'Search',
    usermenu_login_label: 'Login',
    usermenu_signup_label: 'Sign Up',
    usermenu_logout_label: 'Logout',
    usermenu_account_label: 'Account',
    usermenu_appointments_label: 'Appointments',
    usermenu_messages_label: 'Messages',
    usermenu_services_label: 'Services',
    usermenu_venues_label: 'Places',
    usermenu_profile_label: 'Profile',
  },
  register: {
    modal_title: 'Register',
    modal_header_title: 'Welcome to {{name}}',
    modal_header_subtitle: 'Create an account',
    modal_submit_btn_label: 'Continue',
    modal_google_btn_label: 'Continue with Google',
    modal_input_firstname_label: 'First name',
    modal_input_lastname_label: 'Last name',
    modal_input_email_label: 'Email',
    modal_input_phone_label: 'Phone number',
    modal_input_password_label: 'Password',
    modal_input_confirm_password_label: 'Confirm Password',
    modal_login_text: 'Already have an account?',
    modal_login_label: 'Log in',
    modal_beta_disclaimer:
      'We are currently in beta! Account creation is still disabled',
    validation_error_first_name_required: 'First name is required',
    validation_error_first_name_long: 'First name too long!',
    validation_error_first_name_short: 'First name too short!',
    validation_error_last_name_required: 'Last name is required',
    validation_error_last_name_long: 'Last name too long!',
    validation_error_last_name_short: 'Last name too short!',
    validation_error_email_required: 'Email is required',
    validation_error_email_invalid: 'Email not valid',
    validation_error_password_required: 'Password is required',
    validation_error_password_short:
      'Password length should be at least 6 characters',
    validation_error_password_long:
      'Password cannot exceed more than 40 characters',
    validation_error_confirm_password_required: 'Confirm password is required',
    validation_error_confirm_password_short:
      'Password length should be at least 6 characters',
    validation_error_confirm_password_long:
      'Password cannot exceed more than 40 characters',
    validation_error_confirm_password_mismatch: 'Passwords do not match',
    notification_account_created: 'Account created!',
    notification_cannot_create_account: 'Cannot create account',
  },
  forgot: {
    modal_title: 'Forgot password',
    modal_header_title: 'Reset your password',
    modal_header_subtitle: 'Enter your email address',
    modal_input_email_label: 'Email',
    modal_submit_btn_label: 'Reset',
    modal_register_text: 'First time using {{name}}?',
    modal_register_label: 'Create an account',
    validation_error_email_required: 'Email is required',
    validation_error_email_invalid: 'Email not valid',
    notification_email_sent: 'Email sent!',
    notification_cannot_reset: 'Cannot reset account',
  },
  reset: {
    modal_title: 'Reset password',
    modal_header_title: 'Reset your password',
    modal_header_subtitle: 'Enter your new password',
    modal_input_password_label: 'New Password',
    modal_input_confirm_password_label: 'Confirm New Password',
    modal_submit_btn_label: 'Reset',
    modal_register_text: 'First time using {{name}}?',
    modal_register_label: 'Create an account',
    notification_code_not_found: 'reset code not found',
    notification_reset_success: 'Password updated!',
    notification_reset_failure: 'Cannot update password',
    validation_error_password_required: 'Password is required',
    validation_error_password_short:
      'Password length should be at least 6 characters',
    validation_error_password_long:
      'Password cannot exceed more than 40 characters',
    validation_error_confirm_password_required: 'Confirm password is required',
    validation_error_confirm_password_short:
      'Password length should be at least 6 characters',
    validation_error_confirm_password_long:
      'Password cannot exceed more than 40 characters',
    validation_error_confirm_password_mismatch: 'Passwords do not match',
  },
  confirm: {
    notification_code_not_found: 'confirmation code not found',
    notification_code_not_valid: 'confirmation code not valid',
    notification_success: 'Account confirmed!',
  },
  login: {
    modal_title: 'Login',
    modal_header_title: 'Welcome back',
    modal_header_subtitle: 'Login to your account',
    modal_input_email_label: 'Email',
    modal_input_password_label: 'Password',
    modal_submit_btn_label: 'Continue',
    modal_register_text: 'First time using {{name}}?',
    modal_register_label: 'Create an account',
    modal_forgot_text: 'Forgot password?',
    modal_google_btn_label: 'Continue with Google',
    validation_error_email_required: 'Email is required',
    validation_error_email_invalid: 'Email not valid',
    validation_error_password_required: 'Password is required',
    validation_error_password_short:
      'Password length should be at least 6 characters',
    validation_error_password_long:
      'Password cannot exceed more than 40 characters',
    notification_cannot_login: 'Email or password wrong',
  },
  join: {
    modal_title: 'Add me to the list',
    modal_submit_btn_label: 'Submit',
    modal_create_btn_label: 'Create',
    modal_success_btn_label: 'Continue',
    modal_next_btn_label: 'Next',
    modal_back_btn_label: 'Back',
    modal_step_categories_heading_title: 'What best describes your expertise?',
    modal_step_categories_heading_subtitle: 'Choose one category',
    modal_step_location_heading_title: 'Where is your business located?',
    modal_step_location_heading_subtitle: 'Help people find you!',
    modal_step_location_select_country_placeholder: 'Select a Country',
    modal_step_location_select_state_placeholder: 'Select a State / Region',
    modal_step_location_select_city_placeholder: 'Select a City',
    modal_step_location_no_countries_label: 'No result',
    modal_step_location_no_cities_label: 'No result',
    modal_step_location_enter_address_label: 'Enter the address',
    modal_step_location_tip_text:
      "If we can't find your address or is not accurate you can click on the map to place the marker on the exact location",
    modal_step_hours_heading_title: 'What are you business hours?',
    modal_step_hours_heading_subtitle:
      'The hours to book an appointment with you!',
    modal_step_hours_closed_label: 'Closed',
    modal_step_service_heading_title: 'What do you do?',
    modal_step_service_heading_subtitle:
      'Describe one of the services you offer',
    modal_step_service_label_name: 'Service name',
    modal_step_service_label_description: 'Service description',
    modal_step_service_label_duration: 'Duration (minutes)',
    modal_step_service_label_price: 'Price',
    modal_step_service_placeholder_name: 'First appointment',
    modal_step_service_placeholder_description:
      'The first step for an healthier life',
    validation_step_location_error_address_required: 'Address is required',
    validation_step_service_error_name_required: 'Name is required',
    validation_step_service_error_name_short: 'Name too short!',
    validation_step_service_error_name_long: 'Name too long!',
    validation_step_service_error_description_required:
      'Description is required',
    validation_step_service_error_description_short: 'Description too short!',
    validation_step_service_error_description_long: 'Description too long!',
    validation_step_service_error_duration_required: 'Duration is required',
    validation_step_service_error_duration_number: 'Duration must be a number',
    validation_step_service_error_duration_minimum:
      'The minimum duration is {minutes} minutes',
    validation_step_service_error_price_required: 'Price is required',
    validation_step_service_error_price_number: 'Price must be a number',
    validation_step_service_error_price_positive: 'Price not valid',
    modal_step_photo_heading_title: 'Add your profile photo',
    modal_step_photo_heading_subtitle:
      'Match our example style to increase views',
    modal_step_photo_droplet_label: 'Drop an Image or Click to upload',
    modal_step_photo_notification_image_small: 'Image too small',
    modal_step_success_error_message:
      'Oops, it seems that we cannot add you to the list at the moment',
    modal_step_success_summary_line_a: 'Hurray!',
    modal_step_success_summary_line_b:
      'Thank you for helping us growing our network of amazing people!',
    modal_step_success_summary_line_c_pending:
      'Our team will review your request as soon as possible and you will receive an email from us once the review is complete.',
    modal_step_success_summary_line_c_approved:
      'Welcome to {{name}}. We recommend that you complete all of your public profile information. The more details we have, the more we can help you and others find you.',
  },
  search: {
    modal_title: 'Search',
    modal_submit_btn_label: 'Search',
  },
  profile_page: {
    biography_section_label: 'Biography',
    total_reviews_summary: '{{amount}} reviews',
    show_all_reviews_btn_label: 'Show all {{amount}} reviews',
    available_appointments_header: 'Available times',
    available_services_empty_label: 'No service available',
    available_appointments_empty_label: 'No time available',
    available_services_header: 'Services',
    service_duration_label: '{{duration}} minutes',
    summary_total_reviews_label: '{{amount}} reviews',
    edit_profile: 'Edit profile',
    edit_venues: 'Edit venues',
    edit_services: 'Edit services',
    edit_hours: 'Edit hours',
    edit_bio: 'Edit biography',
    no_bio: 'No biography',
    notification_update_title_success_message: 'Profile updated',
    notification_update_title_failure_message: 'Cannot update profile',
    gender_1: 'Doc.',
    gender_2: 'Doc.',
    gender_3: 'Doc.',
    api_error_cannot_create_appointment_message: 'Cannot create appointment',
  },
  not_found_page: {
    not_found_title: "This page doesn't exist",
    not_found_message: "Sorry but this page doesn't exist",
    go_home_button_label: 'This one does',
  },
  hours: {
    closed_label: 'Closed',
  },
  cookie_banner: {
    banner_title: 'Cookie Notice',
    banner_text:
      '<0>We believe your data is your property and support your right to privacy and transparency.</0> We use cookies to enhance your browsing experience, serve personalized ads or consent, and analyze our traffic. By clicking <1>Accept All</1> you consent to our use of cookies. Read more in our <2>Cookie Policy</2> and <3>Privacy Policy</3>.',
    banner_btn_customize_label: 'Customize',
    banner_btn_confirm_choices_label: 'Confirm my choices',
    banner_btn_reject_label: 'Necessary cookies only',
    banner_btn_accept_all_label: 'Accept all',
  },
  cart: {
    appointment_service_name_label: 'Service',
    appointment_service_address_label: 'Location',
    appointment_service_time_label: 'Appointment',
    appointment_action_button_label: 'Book appointment',
    appointment_action_button_short_label: 'Book',
    no_slots_available_main: 'No available time slots',
    change_time_main: 'Change selected time period',
    change_business_main: 'Change selected location',
    no_payment_required: 'No obligation, no payment required',
    no_slots_available_description:
      'The professional is currently unavailable. Try changing the selected time period or location to find availability.',
    no_slots_available_mobile_description:
      'The professional is currently unavailable. Tap to change the time period and find availability.',
  },
  available_appointments: {
    modal_title: 'Available times',
    modal_submit_btn_label: 'Continue',
    modal_confirm_btn_label: 'Confirm',
    modal_cancel_btn_label: 'Back',
    modal_change_business_btn_label: 'Change selected place',
  },
  available_businesses: {
    modal_title: 'Available places',
    modal_submit_btn_label: 'Continue',
    modal_no_business_available: 'No business available',
  },
  available_services: {
    modal_title: 'Available services',
    modal_submit_btn_label: 'Continue',
  },
  reviews: {
    modal_title: 'Reviews',
    modal_submit_btn_label: 'Continue',
  },
  review_details: {
    modal_title: 'Review',
    modal_submit_btn_label: 'Close',
  },
  chat_user_details: {
    modal_submit_btn_label: 'Close',
  },
  contact_confirmation: {
    modal_title: 'Confirm',
    modal_submit_btn_label: 'Book',
    notes_placeholder: 'Notes',
    notes_default_value: 'Hello,\nI would like to book an appointment',
    validation_notes_long: 'Message too long',
  },
  upload_profile_picture: {
    modal_title: 'Upload profile picture',
    modal_submit_btn_label: 'Delete',
    modal_next_btn_label: 'Next',
    modal_back_btn_label: 'Back',
    modal_cancel_btn_label: 'Cancel',
    api_upload_failure: 'Cannot update',
    api_upload_success: 'Profile picture updated',
    api_delete_failure: 'Cannot delete',
    api_delete_success: 'Profile picture deleted',
  },
  delete_account: {
    modal_title: 'Delete account',
    modal_submit_btn_label: 'Delete',
    modal_cancel_btn_label: 'Cancel',
    modal_disclaimer_text:
      'Deleting your account will remove all of your information from our database. This cannot be undone.',
    modal_delete_text: 'To confirm this, please enter your password',
    validation_error_password_required: 'Password is required',
    validation_error_password_short:
      'Password length should be at least 6 characters',
    validation_error_password_long:
      'Password cannot exceed more than 40 characters',
    api_error_cannot_delete_message: 'Cannot delete account',
    api_error_password_wrong_message: 'Password is incorrect',
  },
  change_password: {
    modal_title: 'Change password',
    modal_submit_btn_label: 'Save',
    modal_cancel_btn_label: 'Cancel',
    api_error_cannot_delete_message: 'Cannot change password',
    api_error_password_wrong_message: 'Currenct password is incorrect',
    validation_error_password_required: 'Password is required',
    validation_error_password_short:
      'Password length should be at least 6 characters',
    validation_error_password_long:
      'Password cannot exceed more than 40 characters',
    validation_error_confirm_password_required: 'Confirm password is required',
    validation_error_confirm_password_short:
      'Password length should be at least 6 characters',
    validation_error_confirm_password_long:
      'Password cannot exceed more than 40 characters',
    validation_error_confirm_password_mismatch: 'Passwords do not match',
    validation_error_confirm_password_different:
      'New password should be different',
    modal_header_title: 'Update password',
    modal_header_subtitle: 'Change your current password',
    modal_input_new_password_label: 'Enter your new password',
    modal_input_confirm_new_password_label: 'Confirm your current password',
  },
  contact_details: {},
  new_appointment: {
    modal_title: 'New Appointment',
    modal_submit_btn_label: 'Continue',
    modal_create_btn_label: 'Create appointment',
    modal_success_btn_label: 'Close',
    modal_back_btn_label: 'Back',
    modal_step_service_heading_title: 'Select a service',
    modal_step_service_heading_subtitle:
      'What service for the new appointment?',
    modal_step_time_heading_title: 'Select a time',
    modal_step_time_heading_subtitle: 'What time for the new appointment?',
    modal_step_specific_time_heading_title: 'Select a specific period',
    modal_step_specific_time_heading_subtitle:
      'What time for the new appointment?',
    modal_step_force_time_heading_title: 'Select a day',
    modal_step_force_time_warning_free_limit:
      'You may have reached the appointment limit for the selected month. Upgrade to the Unlimited tier to create unlimited appointments.',
    modal_step_new_contact_warning_free_limit:
      'You’ve reached the contact limit for your current subscription tier. Upgrade to the Unlimited tier to keep creating unlimited contacts',
    modal_step_force_time_heading_subtitle: 'What day for the new appointment?',
    modal_step_force_hour_heading_title: 'Select an hour',
    modal_step_force_business_heading_title: 'Select a place',
    modal_step_specific_hour_heading_title: 'Select a specific hour',
    modal_step_specific_hour_heading_subtitle:
      'What time for the new appointment?',
    modal_step_contact_heading_title: 'Select a contact',
    modal_step_contact_heading_subtitle: 'Who is the new appointment for?',
    modal_step_new_contact_heading_title: 'New contact',
    modal_step_new_contact_heading_subtitle: 'Who is the new appointment for?',
    modal_step_summary_heading_title: 'Confirm new appointment',
    modal_step_summary_heading_subtitle:
      'Please check the data is correct before creating it',
    modal_step_success_heading_title: 'Appointment created successfully!',
    modal_step_success_heading_subtitle: 'Share the appointment details',
    service_duration_label: '{{duration}} minutes',
    contact_search_input_label: 'Search',
    no_contact_found_label: 'No contacts found',
    new_contact_input_first_name_label: 'First name',
    new_contact_input_last_name_label: 'Last name',
    new_contact_input_email_label: 'Email (optional)',
    new_contact_input_phone_label: 'Phone (optional)',
    validation_error_new_contact_first_name_required: 'First name is required!',
    validation_error_new_contact_first_name_long: 'First name too long!',
    validation_error_new_contact_first_name_short: 'First name too short!',
    validation_error_new_contact_last_name_required: 'Last name is required!',
    validation_error_new_contact_last_name_long: 'Last name too long!',
    validation_error_new_contact_last_name_short: 'Last name too short!',
    validation_error_new_contact_email_invalid: 'Email not valid',
    validation_error_new_contact_phone_invalid: 'Phone number not valid',
    notification_success_message: 'Appointment successfully created',
    notification_failure_message: 'Error while creating the appointment',
    modal_step_specific_time_button_label: 'Select a specific period',
    notes_placeholder: 'Add appointment notes',
    validation_notes_long: 'Message too long',
    force_hour_button_label: 'Add anyway',
    specify_time_button_label: 'Other time',
    new_contact_checkbox_gdpr_label: 'Consent to data processing',
    new_contact_checkbox_marketing_label:
      'Consent to communication and promotions',
    button_label_send_whatsapp_notification: 'Send confirmation via WhatsApp',
    button_label_send_sms_notification: 'Send confirmation via SMS',
    confirm_send_whatsapp_reminder_disclaimer_text:
      'Send a WhatsApp reminder to {{name}}?',
    confirm_send_whatsapp_reminder_disclaimer_cancel_label: 'Cancel',
    confirm_send_whatsapp_reminder_disclaimer_confirm_label: 'Send',
    confirm_send_sms_reminder_disclaimer_text:
      'Send a text reminder to {{name}}?',
    confirm_send_sms_reminder_disclaimer_cancel_label: 'Cancel',
    confirm_send_sms_reminder_disclaimer_confirm_label: 'Send',
    confirm_add_contact_phone_disclaimer_text:
      'This contact has no phone number. Want to add it?',
    confirm_add_contact_phone_disclaimer_cancel_label: 'Cancel',
    confirm_add_contact_phone_disclaimer_confirm_label: 'Add number',
  },
  move_appointment: {
    modal_title: 'Reschedule Appointment',
    modal_success_btn_label: 'Close',
    modal_create_btn_label: 'Reschedule',
    modal_submit_btn_label: 'Continue',
    modal_back_btn_label: 'Back',
    notification_success_message: 'Appointment moved successfully',
    notification_failure_message: 'Cannot move appointment',
    modal_step_summary_heading_title: 'Confirm move appointment',
    modal_step_summary_heading_subtitle:
      'Please check the data is correct before moving it',
    modal_step_success_heading_title: 'Appointment moved successfully!',
    modal_step_success_heading_subtitle: 'Share the appointment details',
    modal_step_time_heading_title: 'Select a time',
    modal_step_time_heading_subtitle:
      'What time for the rescheduled appointment?',
    modal_step_specific_time_heading_title: 'Select a specific period',
    modal_step_specific_time_heading_subtitle:
      'What time for the rescheduled appointment?',
    button_label_send_whatsapp_notification: 'Send confirmation via WhatsApp',
    button_label_send_sms_notification: 'Send confirmation via SMS',
    confirm_send_whatsapp_reminder_disclaimer_text:
      'Send a WhatsApp reminder to {{name}}?',
    confirm_send_whatsapp_reminder_disclaimer_cancel_label: 'Cancel',
    confirm_send_whatsapp_reminder_disclaimer_confirm_label: 'Send',
    confirm_send_sms_reminder_disclaimer_text:
      'Send a text reminder to {{name}}?',
    confirm_send_sms_reminder_disclaimer_cancel_label: 'Cancel',
    confirm_send_sms_reminder_disclaimer_confirm_label: 'Send',
    confirm_add_contact_phone_disclaimer_text:
      'This contact has no phone number. Want to add it?',
    confirm_add_contact_phone_disclaimer_cancel_label: 'Cancel',
    confirm_add_contact_phone_disclaimer_confirm_label: 'Add number',
  },
  cancel_appointment: {
    modal_title: 'Delete Appointment',
    modal_step_cancel_appointment_heading_title:
      'Select the reason for the cancellation',
    modal_step_cancel_appointment_heading_subtitle: 'Select the correct option',
    modal_submit_btn_label: 'Delete Appointment',
    modal_back_btn_label: 'Back',
    modal_step_cancel_appointment_notes_placeholder: 'Add notes',
  },
  new_contact: {
    modal_title: 'New Contact',
    modal_submit_btn_label: 'Create',
    modal_step_new_contact_heading_title: 'New Contact',
    modal_step_new_contact_heading_subtitle:
      'Please enter the data for the new contact',
    notification_success_message: 'Contact created successfuly',
    notification_failure_message: 'Cannot create contact',
  },
  edit_biography: {
    modal_title: 'Edit biography',
    modal_submit_btn_label: 'Save',
    modal_heading_title: 'Biography',
    modal_heading_subtitle: 'Add your biography',
    notification_success_message: 'Biography updated successfuly',
    notification_failure_message: 'Cannot update biography',
    biography_placeholder: 'Add your biography',
    validation_biography_long: 'Biography too long',
  },
  generic: {
    closed: 'Closed',
    back: 'Back',
    functionality_in_progress: 'This feature will be released soon',
    weekday_monday: 'Monday',
    weekday_tuesday: 'Tuesday',
    weekday_wednesday: 'Wednesday',
    weekday_thursday: 'Thursday',
    weekday_friday: 'Friday',
    weekday_saturday: 'Saturday',
    weekday_sunday: 'Sunday',
    weekday_1: 'Monday',
    weekday_2: 'Tuesday',
    weekday_3: 'Wednesday',
    weekday_4: 'Thursday',
    weekday_5: 'Friday',
    weekday_6: 'Saturday',
    weekday_7: 'Sunday',
    expert_in: 'Expert in',
    next_available: 'Available from',
    not_available: 'Currently not available',
    show_all: 'Show all',
    hide_all: 'Show less',
    show_more_options: 'Show more hours',
    show_more_services: 'Show all services',
    hide_more_services: 'Show less',
    show_more_businesses: 'Show more places',
    show_no_businesses: 'No places',
    share_button_label: 'Share',
    save_button_label: 'Save',
    show_map: 'Show map',
    show_map_short: 'Map',
    show_list: 'Show list',
    show_list_short: 'List',
    no_results: 'No result found',
    no_hours_available: 'No time available',
    address_not_found: 'Address not found',
    contact_not_found: 'Contact not found',
    treatment_not_found: 'Treatment not found',
    edit_label: 'Edit',
    selector_placeholder: 'Select...',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    this_week_day: '{{name}}',
    gender_1: 'Doc.',
    gender_2: 'Doc.',
    gender_3: 'Doc.',
    and: ' and ',
    in_city: 'in {{city}}',
    account_tier_name_0: 'Unknown',
    account_tier_name_1: 'Free',
    account_tier_name_2: 'Pro',
    account_tier_name_3: 'Unlimited',
  },
  logo: {
    account_tier_name_0: 'Unknown Tier',
    account_tier_name_1: 'Free Tier',
    account_tier_name_2: 'Pro Tier',
    account_tier_name_3: 'Unlimited Tier',
  },
  prices: {
    unexpected_error_label: 'Cannot upgrade tier now',
    most_popular_label: 'Most popular',
    payment_period_selector_yearly_label: 'Yearly',
    payment_period_selector_yearly_discount_label: '-20%',
    payment_period_selector_monthly_label: 'Monthly',
    paid_suffix: ' /month',
    free_suffix: 'forever',
    purchase_plan_btn_label: 'Purchase Plan',
    start_free_trial_btn_label: 'Start free trial',
    sign_up_btn_label: 'Sign up, it’s free!',
    upgrade_btn_label: 'Upgrade to {{tier_name}}',
    included_label: 'Included',
    your_plan_label: 'Your plan',
    features_section_title: 'Includes:',
    account_tier_card_description_1:
      'Perfect for getting started: free appointment and patient management to launch your career.',
    account_tier_card_description_2:
      'Boost your practice with more appointments, unlimited patients and locations. Invest in your professional success.',
    account_tier_card_description_3:
      'Take your practice to the next level: unlimited management for exceptional results and continuous growth.',
    account_tier_card_feature_description_tier_1_feature_1:
      'Up to 20 appointments /month',
    account_tier_card_feature_description_tier_2_feature_1:
      'Up to 100 appointments /month',
    account_tier_card_feature_description_tier_3_feature_1:
      'Unlimited appointments',
    account_tier_card_feature_description_tier_1_feature_2:
      'Up to 50 scheduled appointments',
    account_tier_card_feature_description_tier_2_feature_2:
      'Up to 250 scheduled appointments',
    account_tier_card_feature_description_tier_3_feature_2:
      'Unlimited appointment scheduling',
    account_tier_card_feature_description_tier_1_feature_3:
      'Up to 50 patients in contact list',
    account_tier_card_feature_description_tier_2_feature_3:
      'Unlimited patient contact list',
    account_tier_card_feature_description_tier_3_feature_3:
      'Unlimited patient contact list',
    account_tier_card_feature_description_tier_1_feature_4: '1 work location',
    account_tier_card_feature_description_tier_2_feature_4:
      'Unlimited work locations',
    account_tier_card_feature_description_tier_3_feature_4:
      'Unlimited work locations',
    account_tier_card_feature_description_tier_1_feature_5:
      'Up to 3 treatment types',
    account_tier_card_feature_description_tier_2_feature_5:
      'Unlimited treatment types',
    account_tier_card_feature_description_tier_3_feature_5:
      'Unlimited treatment types',
    account_tier_card_feature_description_tier_1_feature_6:
      'Patient history, treatment reports and personal records',
    account_tier_card_feature_description_tier_2_feature_6:
      'Patient history, treatment reports and personal records',
    account_tier_card_feature_description_tier_3_feature_6:
      'Patient history, treatment reports and personal records',
    account_tier_card_feature_description_tier_1_feature_7:
      'Customizable WhatsApp and SMS reminders',
    account_tier_card_feature_description_tier_2_feature_7:
      'Customizable WhatsApp and SMS reminders',
    account_tier_card_feature_description_tier_3_feature_7:
      'Customizable WhatsApp and SMS reminders',
    account_tier_card_feature_description_tier_1_feature_8: 'Online bookings',
    account_tier_card_feature_description_tier_2_feature_8: 'Online bookings',
    account_tier_card_feature_description_tier_3_feature_8: 'Online bookings',
    account_tier_card_feature_description_tier_1_feature_9:
      'Appointment and patient statistics',
    account_tier_card_feature_description_tier_2_feature_9:
      'Appointment and patient statistics',
    account_tier_card_feature_description_tier_3_feature_9:
      'Appointment and patient statistics',
    account_tier_card_feature_description_tier_1_feature_10: 'Patient chat',
    account_tier_card_feature_description_tier_2_feature_10: 'Patient chat',
    account_tier_card_feature_description_tier_3_feature_10: 'Patient chat',
    account_tier_card_feature_description_tier_1_feature_11:
      'Temporary closures',
    account_tier_card_feature_description_tier_2_feature_11:
      'Temporary closures',
    account_tier_card_feature_description_tier_3_feature_11:
      'Temporary closures',
  },
  categories: {
    '8f3ba120-4d8c-4c1e-b627-88fc757f1c64': 'Sport',
    'dabacad0-6a67-4e24-b31f-df13567bacb5': 'Pregnancy',
    '9067e082-a828-4ea5-8276-76029b021cc8': 'Fragile',
    '2145b2b7-7bf2-47d5-928a-292453059b0f': 'Toddlers',
    '2700fc13-6e0a-4e25-a216-262d0225f661': 'Recovery',
    '1150faac-63b3-44b2-8fd0-33ce21fc5e96': 'Pets',
    'f880ca79-e0ce-4fbf-b1bb-81c338dcd6b4': 'Injuries',
    'c2751259-cdc5-4214-82d3-29b1e4b3b80c': 'Posture',
    '0e98b079-6395-46a0-829c-200c1a71a479': 'Wellbeing',
    '4c9f1da7-d3d4-4765-9834-55f3f6b0529c': 'Biodynamic',
  },
  language: {
    language_name_en: 'English',
    language_name_it: 'Italian',
  },
  account: {
    modal_input_email_label: 'Email',
    modal_input_timezone_label: 'Timezone',
    modal_input_language_label: 'Language',
    modal_input_currency_label: 'Currency',
    modal_input_firstname_label: 'First name',
    modal_input_lastname_label: 'Last name',
    button_label_change_password: 'Change Password',
    button_label_delete_account: 'Delete Account',
    button_label_logout_account: 'Logout',
    button_label_save: 'Save',
    button_label_cancel: 'Cancel',
    validation_error_first_name_required: 'First name is required',
    validation_error_first_name_long: 'First name too long!',
    validation_error_first_name_short: 'First name too short!',
    validation_error_last_name_required: 'Last name is required',
    validation_error_last_name_long: 'Last name too long!',
    validation_error_last_name_short: 'Last name too short!',
    page_title_meta: 'My account on {{name}}',
    preferences_section_title: 'Notifications',
    preferences_not_available_label: 'Not available',
    preferences_email_notification_switch_label:
      'Email notifications (messages, appointments, ...)',
    preferences_push_notification_switch_label:
      'Push notifications (messages, appointments, ...)',
    confirm_profile_image_delete: 'Do you want to delete your profile image?',
    confirm_profile_image_delete_cancel_label: 'Cancel',
    confirm_profile_image_delete_confirm_label: 'Yes, delete it',
  },
  chat: {
    message_header_new_appointment_banner: 'New appointment with {{name}}',
    message_header_appointment_new_mine:
      'You asked for a new appointment with {{name}}',
    message_header_appointment_new_other:
      '{{name}} asked for a new appointment',
    message_header_appointment_confirmed_other:
      '{{name}} accepted the appointment',
    message_header_appointment_confirmed_mine:
      'You accepted the appointment with {{name}}',
    message_header_appointment_canceled_mine:
      'You canceled the appointement with {{name}}',
    message_header_appointment_canceled_other:
      '{{name}} canceled the appointment',
    message_header_appointment_complete_mine:
      'The appointment with {{name}} ended',
    message_header_appointment_complete_other:
      'The appointment with {{name}} ended',
    message_header_appointment_change_request_mine:
      'You asked to change the appointment with {{name}}',
    message_header_appointment_change_request_other:
      '{{name}} asked to change the appointment',
    message_header_appointment_cancel_request_mine:
      'You asked to cancel the appointment with {{name}}',
    message_header_appointment_cancel_request_other:
      '{{name}} asked to cancel the appointment',
    message_header_appointment_change_denied_mine:
      '{{name}} cannot change the appointment',
    message_header_appointment_change_denied_other:
      'You denied changing the appointement with {{name}}',
    message_header_appointment_new_denied_other:
      '{{name}} cannot accept the appointment',
    message_header_appointment_new_denied_mine:
      'You denied the appointement with {{name}}',
    message_header_appointment_cancel_denied_mine:
      '{{name}} cannot cancel the appointment',
    message_header_appointment_cancel_denied_other:
      'You denied canceling the appointement with {{name}}',
    message_header_appointment_changed_other:
      '{{name}} accepted the appointment',
    message_header_appointment_changed_mine:
      'You accepted the appointment with {{name}}',
    button_label_modify_appointment: 'Edit',
    button_label_confirm_appointment: 'Confirm',
    button_label_abort_appointment: 'Cancel',
    button_label_cancel_appointment: 'Cancel',
    button_label_deny_appointment: 'Deny',
    button_label_accept_appointment: 'Accept',
    button_label_delete_appointment: 'Cancel appointment',
    no_conversation_selected_message: 'No conversation selected',
    error_getting_messages: 'We cannot retrieve messages at the moment',
    last_seen_label: 'Last seen',
    online_label: 'Online',
    blocked: 'Blocked',
    blocked_conversation_text: 'This conversation is blocked',
    send_message_label: 'Send message',
    send_message_placeholder: 'Send message...',
    menu_profile_information_label: 'Profile informations',
    menu_enable_notifications_label: 'Enable notifications',
    menu_new_appointment_label: 'New appointment',
    menu_block_contact_label: 'Block contact',
    menu_unblock_contact_label: 'Unblock contact',
    block_user_dialog_text: 'Do you want to block {{name}}?',
    unblock_user_dialog_text: 'Do you want to unblock {{name}}?',
    menu_block_contact_confirm_btn_label: 'Block',
    menu_block_contact_cancel_btn_label: 'Cancel',
    menu_unblock_contact_confirm_btn_label: 'Unblock',
    menu_unblock_contact_cancel_btn_label: 'Cancel',
    push_notification_message_text:
      'Do you want to be notified as soon as {{name}} replies?',
    push_notification_accept_label: "No, I don't want to be notified",
    push_notification_deny_label: 'Yes, I want to be notified',
    push_notification_deny_disclaimer_text:
      'Without instant notification you may not see messages in time for your appointment. Do you want to disable it?',
    push_notification_deny_disclaimer_cancel_label: 'Cancel',
    push_notification_deny_disclaimer_confirm_label:
      "Yes, I don't want to be notified",
    cancel_new_appointment_disclaimer_text:
      'Do you want to cancel the appointment?',
    cancel_new_appointment_disclaimer_cancel_label: 'No',
    cancel_new_appointment_disclaimer_confirm_label: 'Yes, I want to cancel it',
    deny_new_appointment_disclaimer_text:
      'Do you want to deny the appointment?',
    deny_new_appointment_disclaimer_cancel_label: 'No',
    deny_new_appointment_disclaimer_confirm_label: 'Yes, I want to deny it',
    confirm_new_appointment_disclaimer_text:
      'Do you want to confirm the appointment?',
    confirm_new_appointment_disclaimer_cancel_label: 'No',
    confirm_new_appointment_disclaimer_confirm_label:
      'Yes, I want to confirm it',
    request_cancel_appointment_disclaimer_text:
      'Do you want to cancel the appointment?',
    request_cancel_appointment_disclaimer_cancel_label: 'No',
    request_cancel_appointment_disclaimer_confirm_label:
      'Yes, I want to cancel it',
  },
  appointment: {
    next_appointments_label: 'Next appointments',
    past_appointments_label: 'Past appointments',
    pending_appointments_label: 'Waiting for confirmation',
    no_appointments_label: 'No appointments',
    waiting_for_confirmation_label: 'Waiting for confirmation',
    appointment_confirmed_label: 'Appointment confirmed',
    in_progress_label: 'In progress',
    past_appointment_label: 'Appointment over',
    appointment_waiting_for_closure_label: 'Waiting for closure',
  },
  appointment_details: {
    no_appointments_label: 'No appointments',
    add_appointments_label: 'Add appointment',
    new_appointment_button_label: 'New appointment',
    change_plan_button_label: 'Upgrade to Unlimited Tier',
    change_plan_warning_banner_text:
      'You’ve reached the maximum number of appointments included in the Free tier. Upgrade to the Unlimited tier to keep creating unlimited appointments.',
    button_label_more: 'Show more...',
    month_view_popup_label: 'Month view',
    week_view_popup_label: 'Week view',
    day_view_popup_label: 'Day view',
    list_view_popup_label: 'Appointment list',
    today_shortcut: 'Go to Today',
  },
  partner_inreview: {
    in_review_message:
      'We have received your request, and your profile is currently under review. Our team is working to evaluate it as quickly as possible. You will receive an email as soon as the review is complete. Once approved, your profile will be public, and you will be able to accept online bookings. Thank you for your patience!',
    continue_button_label: 'Continue',
  },
  dashboard: {
    side_menu_item_label_overview: 'Charts',
    side_menu_item_label_businesses: 'Workplaces',
    side_menu_item_label_hours: 'Availability',
    side_menu_item_label_hours_temp_hours_closing: 'Temporary closings',
    side_menu_item_label_hours_temp_hours_opening: 'Temporary openings',
    side_menu_item_label_businesse_details: 'Place Details',
    side_menu_item_label_services: 'Services',
    side_menu_item_label_service_details: 'Service Details',
    side_menu_item_label_appointments: 'Calendar',
    side_menu_item_label_temp_hours: 'Temporary closings',
    side_menu_item_label_appointment_details: 'Appointment details',
    side_menu_item_label_clients: 'Patients',
    side_menu_item_label_contact_details: '{{name}}',
    side_menu_item_label_chat: 'Messages',
    side_menu_item_label_search: 'Search',
    side_menu_item_label_preferences: 'Settings',
    side_menu_item_label_logout: 'Logout',
    side_menu_item_label_feedback: 'Leave Feedback',
    side_menu_item_label_treatment_details: 'Treatment Details',
    side_menu_item_label_preferences_account: 'Account',
    side_menu_item_label_preferences_profile: 'Profile Page',
    side_menu_item_label_preferences_cancel_reasons: 'Cancel reasons',
    side_menu_item_label_preferences_payment_methods: 'Type of payments',
    welcome_logo_header: '{{name}}',
    welcome_logo_action_label: 'Go to Dashboard',
    clients_section: {
      warning_free_limit:
        'You’ve reached the contact limit for your current subscription tier. Upgrade to the Unlimited tier to keep creating unlimited contacts',
      no_contact_found_label: 'No contacts found',
      contact_search_input_label: 'Search',
    },
    appointments_section: {
      no_appointments_label: 'No appointments',
      add_appointments_label: 'Add appointment',
      new_appointment_button_label: 'New appointment',
      button_label_more: 'Show more...',
      month_view_popup_label: 'Month view',
      week_view_popup_label: 'Week view',
      day_view_popup_label: 'Day view',
      list_view_popup_label: 'Appointments list',
      today_shortcut: 'Go to Today',
    },
    appointment_details_section: {
      appointment_not_found_notification_text: 'Appointment not found',
      cancel_appointment_dialog_text:
        'Do you want to cancel the appointment with {{name}}?',
      cancel_appointment_confirm_btn_label: 'Yes, cancel it',
      cancel_appointment_cancel_btn_label: 'Cancel',
      appointment_canceled_notification_text: 'Appointment canceled',
      appointment_cancel_error_notification_text:
        'Unable to cancel appointment',
      appointment_confirmed_notification_text: 'Appointment confirmed',
      appointment_confirm_error_notification_text:
        'Unable to confirm appointment',
      warning_schedule_conflict_text:
        'This appointment overlaps with other appointments in your calendar',
      cancel_new_appointment_disclaimer_text:
        'Do you want to cancel the appointment?',
      cancel_new_appointment_disclaimer_cancel_label: 'No',
      cancel_new_appointment_disclaimer_confirm_label:
        'Yes, I want to cancel it',
      deny_new_appointment_disclaimer_text:
        'Do you want to reject the appointment?',
      deny_new_appointment_disclaimer_cancel_label: 'No',
      deny_new_appointment_disclaimer_confirm_label: 'Yes, I want to reject it',
      confirm_new_appointment_disclaimer_text:
        'Do you want to confirm the appointment?',
      confirm_new_appointment_disclaimer_cancel_label: 'No',
      confirm_new_appointment_disclaimer_confirm_label:
        'Yes, I want to confirm it',
      request_cancel_appointment_disclaimer_text:
        'Do you want to cancel the appointment?',
      request_cancel_appointment_disclaimer_cancel_label: 'No',
      request_cancel_appointment_disclaimer_confirm_label:
        'Yes, I want to cancel it',
      button_label_move_appointment: 'Reschedule appointment',
      button_label_cancel_appointment: 'Cancel appointment',
      button_label_confirm_appointment: 'Confirm appointment',
      button_label_complete_appointment: 'Complete appointment',
      button_label_back: 'Back',
      button_label_show_conversation: 'Show conversation',
      notes_section_name: 'Patient notes',
      partner_notes_section_name: 'Your notes',
      button_label_send_whatsapp_notification: 'Send WhatsApp reminder',
      button_label_send_sms_notification: 'Send SMS reminder',
      button_label_send_whatsapp_confirmation: 'Send WhatsApp confirmation',
      button_label_send_sms_confirmation: 'Send SMS confirmation',
      confirm_send_whatsapp_reminder_disclaimer_text:
        'Send WhatsApp reminder to {{name}}?',
      confirm_send_whatsapp_reminder_disclaimer_cancel_label: 'Cancel',
      confirm_send_whatsapp_reminder_disclaimer_confirm_label: 'Send',
      confirm_send_sms_reminder_disclaimer_text:
        'Send SMS reminder to {{name}}?',
      confirm_send_sms_reminder_disclaimer_cancel_label: 'Cancel',
      confirm_send_sms_reminder_disclaimer_confirm_label: 'Send',
      confirm_add_contact_phone_disclaimer_text:
        'This contact does not have a phone number. Do you want to add it?',
      confirm_add_contact_phone_disclaimer_cancel_label: 'Cancel',
      confirm_add_contact_phone_disclaimer_confirm_label: 'Add number',
      confirm_send_whatsapp_confirm_disclaimer_text:
        'Send WhatsApp confirmation to {{name}}?',
      confirm_send_whatsapp_confirm_disclaimer_cancel_label: 'Cancel',
      confirm_send_whatsapp_confirm_disclaimer_confirm_label: 'Send',
      confirm_send_sms_confirm_disclaimer_text:
        'Send SMS confirmation to {{name}}?',
      confirm_send_sms_confirm_disclaimer_cancel_label: 'Cancel',
      confirm_send_sms_confirm_disclaimer_confirm_label: 'Send',
      button_label_show_contact: 'Show contact',
      button_label_ask_review: 'Request review',
      button_label_modify_complete: 'Modify appointment',
      payment_section_label: 'Payment',
      report_section_new_report_btn_label: 'New treatment report',
      report_section_view_report_btn_label: 'Show treatment report',
      report_section_label: 'Treatment report',
      report_section_no_report_label: 'No report',
      status_section_label_0: 'Unknown appointment status: 0',
      status_section_label_1: 'New appointment pending confirmation',
      status_section_label_2: 'Appointment confirmed',
      status_section_label_3: 'Unknown appointment status: 3',
      status_section_label_4: 'Unknown appointment status: 4',
      status_section_label_5: 'Unknown appointment status: 5',
      status_section_label_6: 'Unknown appointment status: 6',
      status_section_label_7: 'Unknown appointment status: 7',
      status_section_label_8: 'Unknown appointment status: 8',
      status_section_label_9: 'Appointment completed',
      status_section_label_10: 'Appointment canceled',
      status_section_label_11: 'Unknown appointment status: 11',
      status_section_label_12: 'Appointment rescheduled',
      notification_report_creation_failure_message: 'Unable to create report',
      confirm_new_report_create: 'Do you want to create a new report?',
      confirm_new_report_create_cancel_label: 'Cancel',
      confirm_new_report_create_confirm_label: 'Create',
    },
    complete_appointment: {
      modal_title: 'Complete appointment',
      modal_modify_title: 'Edit appointment',
      modal_submit_btn_label: 'Continue',
      modal_step_payment_heading_title: 'Payment informations',
      modal_step_payment_heading_subtitle:
        'Enter total and payment method used',
      modal_step_success_heading_title: 'Appointment completed successfully!',
      modal_step_success_heading_subtitle:
        'You can ask for a review or schedule a new appointment with the patient right away',
      button_label_ask_review: 'Ask for a review',
      button_label_modify_complete: 'Edit appointment',
      button_label_next_appointment: 'New appointment',
      button_label_close: 'Close',
      appointment_complete_notification_text: 'Appointment complete!',
      appointment_complete_error_notification_text:
        'Cannot complete appointment',
      modal_step_payment_notes_placeholder: 'Add notes',
      amount_label: 'Total',
    },
    contacts_section: {
      button_label_new_contact: 'New contact',
    },
    page_details_section: {
      button_label_save: 'Save',
      button_label_cancel: 'Cancel',
    },
    anamnesi: {
      generic_label_notes: 'Notes',
      contact_anamnesi_section_label: 'Medical History',
      contact_anamnesi_section_sublabel: 'Last update: {{updated}}',
      anamnesi_section_field_labels: {
        'fc98021d-2126-4e28-a1f3-f660792a6577': 'Reason for consultation',
        '437070ba-76c4-4d54-ac97-ecbec91a159b':
          'Date and circumstances of symptom onset',
        'c4d08b73-a5c7-4188-9cac-0ae9ca1d660e': 'Pain description',
        '1a557502-c069-4ea3-af9a-50d8660f8556': 'Relieving factors',
        '9409d462-762d-4a66-9400-6a167a54a534': 'Worsening factors',
        'e5b1e666-37d4-4060-965c-c0796231b419': 'Investigations performed',
        '9caa19b6-8471-4e16-8d8d-786e151a9d0b':
          'Treatments performed and their response',
        '7dfac186-ac96-4de6-8ca6-0117ec080382': 'Reported disorders',
        'ea6586aa-e12a-481b-8989-4afdbb0b8c9c': 'Past traumas',
        'd056c8c3-d98f-40c0-8173-1fdb48d4b50e': 'Surgical interventions',
        'e122ddba-034b-48fa-b929-0927cbfe240c': 'Allergies',
        '93d43b10-7ef0-43b1-aad8-3dd46fd176c6': 'Lifestyle and sports habits',
        '033f388a-f9a8-4f0a-9a00-be245629507e':
          'Physical sphere (energy/fatigue, sleep quantity/quality)',
        'a1d88e60-0ec3-4bf7-9055-cae213fca7cf':
          'Psychological sphere (anxiety/depression, cyclothymia, meteoropathy)',
        '8848bcbb-4dce-4ce9-ab42-057aa05d1e30': 'Regularly used medications',
        'a94a543a-9403-4642-87b8-9dbba2909be5': 'Occasionally used medications',
        'e8f3ceb1-4dbc-4aba-9fd8-75655cc59d5d': 'Reported disorders',
        'bb26aaf5-f745-48f8-95fc-45c762d0fe79': 'Pain scale',
      },
      anamnesi_section_group_labels: {
        '59158e6c-127a-4b22-a21f-2182f1a5f483': 'Reported pain',
        '16bff906-752d-4851-b45d-4c0d11855db0': "Patient's medical condition",
        '47870f40-9898-4e9a-9cdd-c7b8781b24f7': "Patient's general condition",
        'd1dcf5a6-b10e-4d8d-b726-5535606cfac5': 'Medications used',
      },
      anamnesi_section_field_option_labels: {
        'a424c5c1-75e8-4978-9693-5a4839600053': 'Respiratory/ENT',
        'c65fca4b-9fc9-4055-948c-cd7d722d8970': 'Gastroenterological',
        '763330a2-223a-431c-a6e1-27c0d5d6a35d': 'Endocrine',
        'c1c0062e-9a26-4530-b6ab-af335d9850c8': 'Gynecological',
        '9467a126-16bb-41e2-bc0a-2ce67218d62a': 'Urological',
        '06f3adfb-686b-4668-9a08-508ab5b9bc39': 'Neurological',
        'f2d8c53e-3b63-438d-b9f8-452c86de89db': 'Metabolic',
        'b845e6b5-2749-4873-8d23-e0082e7d1d2e': 'Cardiovascular',
        '6a54a22c-4273-4f8d-9bc5-2daf467ee33a': 'Ophthalmological',
        '87d44367-d692-4d61-99c3-67dcaa046d40': 'Dentistry/Stomatology',
        '0f39d460-1d1e-444b-822d-a43afde47134': 'Other',
        'c9b366a3-5851-41c9-a273-490db54b9ea3': 'No pain',
        'c7e67eff-f8e2-4738-b641-02bf1f80ea3c': 'Mild pain',
        '0a14481e-29e4-4ff0-b55c-754652fb070e': 'Moderate pain',
        '6db002aa-f19e-4605-bf6b-2df07a8fd3c9': 'Severe pain',
        '54d42b90-afb0-4166-a981-b3271098592e': 'Very severe pain',
        '063d010d-b26f-46fb-b4cb-2ebc388b15a7': 'Worst possible pain',
      },
    },
    contact_details_section: {
      section_sublabel: 'Last update: {{updated}}',
      summary_contact_age_label: 'Patient since',
      summary_contact_previous_appointment_label: 'Last appointment',
      summary_contact_total_revenues_label: 'Total revenue',
      summary_contact_total_appointments_label: 'Completed appointments',
      summary_contact_reliability_label: 'Reliability',
      summary_contact_profile_progress_label: 'Profile completion',
      charts_section: 'Statistics',
      contact_basic_section_label: 'Personal information',
      first_name_label: 'First Name',
      last_name_label: 'Last Name',
      email_label: 'Email',
      phone_label: 'Phone',
      gender_label: 'Gender',
      notes_label: 'Notes',
      gender_option_label_0: 'Male',
      gender_option_label_1: 'Female',
      gender_option_label_2: 'Not specified',
      age_label: 'Age',
      age_value_years: '{{years}} years',
      age_value_months: '{{months}} months',
      age_value_days: '{{days}} days',
      birth_label: 'Date of birth',
      ssn_label: 'Social Security Number',
      occupation_label: 'Occupation',
      general_practitioner_label: 'General Practitioner',
      button_label_back: 'Back',
      button_label_modify: 'Edit contact',
      button_label_delete: 'Delete contact',
      button_label_cancel: 'Cancel',
      button_label_save: 'Save',
      button_label_messages: 'Go to Messages',
      button_label_whatsapp: 'Open WhatsApp chat',
      button_label_block: 'Block contact',
      button_label_unblock: 'Unblock contact',
      validation_error_phone: 'Invalid phone number',
      validation_error_email: 'Invalid email',
      validation_error_first_name_required: 'First name required',
      validation_error_first_name_long: 'First name too long',
      validation_error_first_name_short: 'First name too short',
      validation_error_last_name_required: 'Last name required',
      validation_error_last_name_long: 'Last name too long',
      validation_error_last_name_short: 'Last name too short',
      send_email_dialog_text: 'Do you want to send an email to {{name}}?',
      send_email_confirm_btn_label: 'Confirm',
      send_email_cancel_btn_label: 'Cancel',
      call_phone_dialog_text: 'Do you want to call {{name}}?',
      call_phone_confirm_btn_label: 'Confirm',
      call_phone_cancel_btn_label: 'Cancel',
      delete_contact_dialog_text: "Do you want to delete {{name}}'s contact?",
      delete_contact_confirm_btn_label: 'Yes, delete',
      delete_contact_cancel_btn_label: 'Cancel',
      notification_message_contact_deleted: 'Contact deleted',
      notification_message_contact_delete_error: 'Unable to delete contact',
      notification_message_contact_updated: 'Contact updated',
      notification_message_contact_update_error: 'Unable to update contact',
      notification_message_contact_blocked: 'Contact blocked',
      notification_message_contact_block_error: 'Unable to block contact',
      notification_message_contact_unblocked: 'Contact unblocked',
      notification_message_contact_unblock_error: 'Unable to unblock contact',
      block_user_dialog_text: 'Do you want to block {{name}}?',
      unblock_user_dialog_text: 'Do you want to unblock {{name}}?',
      menu_block_contact_confirm_btn_label: 'Block',
      menu_block_contact_cancel_btn_label: 'Cancel',
      menu_unblock_contact_confirm_btn_label: 'Unblock',
      menu_unblock_contact_cancel_btn_label: 'Cancel',
      summary_contact_reliability_value_0: '-',
      summary_contact_reliability_value_1: 'Low',
      summary_contact_reliability_value_2: 'Medium',
      summary_contact_reliability_value_3: 'High',
      summary_contact_reliability_value_4: 'Top',
      appointment_history: {
        notification_retrieve_data_failure: 'Cannot read appointments history',
        section_label: 'Appointments history',
        table_column_a: 'Date',
        table_column_b: 'Service',
        table_column_c: 'Earned',
        table_column_d: 'Status',
        table_column_e: 'Report',
        table_no_results: 'No results',
        table_previous_btn_label: 'Previous',
        table_next_btn_label: 'Next',
        appointment_status_0: 'Unknown',
        appointment_status_10: 'Canceled',
        appointment_status_2: 'Confirmed',
        appointment_status_9: 'Completed',
        appointment_status_12: 'Rescheduled',
      },
      treatment_history: {
        notification_retrieve_data_failure:
          'Unable to load appointment history',
        section_label: 'Treatment Report',
        table_column_a: 'Date',
        table_column_b: 'Service',
        table_column_c: 'Earned',
        table_column_d: 'Status',
        table_column_e: 'Report',
        table_no_results: 'No results',
        table_previous_btn_label: 'Previous',
        table_next_btn_label: 'Next',
      },
      chart_info_description_appointments:
        "The pie chart represents the total distribution of a patient's appointments, visually dividing the percentages of completed, canceled, and rescheduled appointments. Each section of the chart is distinctly colored to enable quick data interpretation. This chart helps understand the patient's habits, highlighting how often they confirm, cancel, or modify their appointments. It is a useful tool for assessing patient reliability and adherence to their treatment plan.",
      chart_info_description_appointment_week_distribution:
        "The stacked bar chart shows the weekly distribution of patients' appointment preferences. The x-axis represents the days of the week, while the y-axis displays the number of appointments, broken down into three categories: Completed, Cancelled, and Rescheduled. Each bar represents a specific day, with each section of the bar colored to indicate one of the three categories. The bars allow for a visual comparison of completed, cancelled, and rescheduled appointments for each day of the week. This chart helps identify days with higher or lower cancellations or reschedules, offering a detailed analysis of weekly trends.",
      chart_info_description_appointment_day_distribution:
        "The stacked bar chart shows the patient's daily preference for appointment times throughout the day. The x-axis represents the hours, while the y-axis indicates the quantities of appointments broken down into three categories: Completed, Cancelled, and Rescheduled. Each hour is represented by a bar made up of color-coded sections to differentiate the appointment statuses. This chart allows for an analysis of which time slots have the highest concentration of completed, cancelled, or rescheduled appointments, providing useful insights for optimizing scheduling and identifying potential problematic times for the patient.",
    },
    services_section: {
      no_service_found_label: 'No service found',
      service_search_input_label: 'Search',
      modal_title: 'New Service',
      modal_submit_btn_label: 'Create Service',
      modal_step_service_heading_title: 'New Service',
      modal_step_service_heading_subtitle: 'Insert the data of the new service',
      validation_step_service_error_name_required: 'Name is required',
      validation_step_service_error_name_short: 'Name too short!',
      validation_step_service_error_name_long: 'Name too long!',
      validation_step_service_error_description_required:
        'Description is required',
      validation_step_service_error_description_short: 'Description too short!',
      validation_step_service_error_description_long: 'Description too long!',
      validation_step_service_error_duration_required: 'Duration is required',
      validation_step_service_error_duration_number:
        'Duration must be a number',
      validation_step_service_error_duration_minimum:
        'The minimum duration is {minutes} minutes',
      validation_step_service_error_price_required: 'Price is required',
      validation_step_service_error_price_number: 'Price must be a number',
      validation_step_service_error_price_positive: 'Price not valid',
      modal_step_service_label_name: 'Service name',
      modal_step_service_label_description: 'Service description',
      modal_step_service_label_duration: 'Duration (minutes)',
      modal_step_service_label_price: 'Price',
      modal_step_service_placeholder_name: 'First appointment',
      modal_step_service_placeholder_description:
        'The first step for an healthier life',
      notification_success_message: 'Service successfully created',
      notification_failure_message: 'Error while creating the service',
      warning_free_limit:
        'You’ve reached the services limit for your current subscription tier. Upgrade to the Pro tier to keep creating unlimited services',
    },
    profile_details_section: {
      completeness_complete_title_label: 'Profile Checklist',
      completeness_inprogress_title_label: 'Complete your profile',
      completeness_step_label_1: 'Professional title',
      completeness_step_label_2: 'Profile picture',
      completeness_step_label_3: 'Biography',
      completeness_step_label_4: 'Places name ({{complete}}/{{total}})',
      completeness_step_label_5: 'Places hours ({{complete}}/{{total}})',
      completeness_step_label_6:
        'Services description ({{complete}}/{{total}})',
      bio_label: 'Biography',
      bio_description_label: 'Add your biography',
      button_label_save_bio: 'Save',
      button_label_cancel_bio: 'Cancel',
      no_bio: 'No biography',
      button_go_to_public_profile: 'Go to public profile',
      button_publish_public_profile: 'Publish public profile',
      button_unpublish_public_profile: 'Unpublish public profile',
      confirm_profile_image_delete: 'Do you want to delete your profile image?',
      confirm_profile_image_delete_cancel_label: 'Cancel',
      confirm_profile_image_delete_confirm_label: 'Yes, delete it',
      confirm_unpublish_text: 'Do you want to unpublish your public profile?',
      confirm_unpublish_cancel_label: 'Cancel',
      confirm_unpublish_confirm_label: 'Yes, unpublish it',
      confirm_publish_text: 'Do you want to publish your public profile?',
      confirm_publish_cancel_label: 'Cancel',
      confirm_publish_confirm_label: 'Yes, publish it',
      notification_unpublish_profile_success: 'Profile unpublished',
      notification_unpublish_profile_failure: 'Cannot unpublish profile',
      notification_publish_profile_success: 'Profile published',
      notification_publish_profile_failure: 'Cannot publish profile',
    },
    treatment_section: {
      section_label: 'Treatment',
      button_label_save: 'Save',
      button_label_cancel: 'Cancel',
      section_sublabel: 'Last update: {{updated}}',
      treatment_section_group_labels: {
        '0dd670f7-bd31-4616-961e-b01b437837c3': 'Details',
      },
      treatment_section_field_labels: {
        '070e02ef-ec35-46c2-bc04-fbcd878d7747': 'Date',
        '4e085fa2-2a38-499d-a5b7-2d324801311c': 'Reason for Treatment',
        '4c101830-ee17-40eb-8ade-f7ac8bb9f85a': 'Patient Status',
        'c9c2f465-78c6-44c0-a17d-9d24178d017a': 'Treatment Description',
        '4e6bd817-8454-4f0e-b107-30b4777a8918': 'Notes',
      },
      treatment_section_field_option_labels: {
        '01b2101b-94e9-4eb0-93eb-25ea5b86ca10': 'Date',
        'f8f7f49f-c3b0-421b-ad4d-7db21c0625ac': 'Reason for Treatment',
        '99eca4a5-a697-4e51-8235-6f2dd81466b5': 'Patient Status',
        '2f2594d2-c5d3-438d-a25e-6ff116682fd1': 'Treatment Description',
        '64b0fcd5-1c03-407b-89da-e08cdc4c0afb': 'Notes',
      },
    },
    service_details_section: {
      button_label_back: 'Back',
      button_label_modify: 'Edit service',
      button_label_delete: 'Delete service',
      button_label_disable: 'Hide service',
      button_label_enable: 'Publish service',
      button_label_save: 'Save',
      button_label_cancel: 'Cancel',
      name_label: 'Name',
      duration_label: 'Duration',
      service_duration_label: '{{duration}} minutes',
      price_label: 'Price',
      description_label: 'Description',
      categories_label: 'Category',
      tags_label: 'Category',
      businesses_label: 'Places',
      no_businesses_label: 'The service is not associated with a location',
      delete_service_dialog_text: 'Do you want to delete {{name}}?',
      delete_service_cancel_btn_label: 'Yes, delete it',
      delete_service_confirm_btn_label: 'Cancel',
      service_deleted_notification_text: 'Service deleted',
      service_delete_error_notification_text: 'Cannot delete service',
      disable_service_dialog_text: 'Do you want to hide {{name}}?',
      disable_service_cancel_btn_label: 'Cancel',
      disable_service_confirm_btn_label: 'Yes, hide it',
      service_disabled_notification_text: 'Service hidden',
      service_disable_error_notification_text: 'Cannot hide service',
      enable_service_dialog_text: 'Do you want to publish {{name}}?',
      enable_service_cancel_btn_label: 'Cancel',
      enable_service_confirm_btn_label: 'Yes, publish it',
      service_enabled_notification_text: 'Service published',
      service_enable_error_notification_text: 'Cannot publish service',
      validation_step_service_error_name_required: 'Name is required',
      validation_step_service_error_name_short: 'Name too short!',
      validation_step_service_error_name_long: 'Name too long!',
      validation_step_service_error_description_required:
        'Description is required',
      validation_step_service_error_description_short: 'Description too short!',
      validation_step_service_error_description_long: 'Description too long!',
      validation_step_service_error_duration_required: 'Duration is required',
      validation_step_service_error_duration_number:
        'Duration must be a number',
      validation_step_service_error_duration_minimum:
        'The minimum duration is {minutes} minutes',
      validation_step_service_error_price_required: 'Price is required',
      validation_step_service_error_price_number: 'Price must be a number',
      validation_step_service_error_price_positive: 'Price not valid',
      service_updated_notification_text: 'Service updated',
      service_update_error_notification_text: 'Cannot update service',
      service_switched_active_notification_text: 'Service enabled',
      service_switch_active_error_notification_text: 'Cannot enable service',
      service_switched_inactive_notification_text: 'Service hidden',
      service_switch_inactive_error_notification_text: 'Cannot hide service',
    },
    businesses_section: {
      no_business_found_label: 'No place found',
      business_search_input_label: 'Search',
      modal_title: 'New Place',
      modal_submit_btn_label: 'Create Place',
      modal_step_location_heading_title: 'Where is your business located?',
      modal_step_location_heading_subtitle: 'Help people find you!',
      modal_next_btn_label: 'Next',
      modal_back_btn_label: 'Back',
      modal_create_btn_label: 'Create',
      notification_success_message: 'Place successfully created',
      notification_failure_message: 'Error while creating the place',
      business_switched_inactive_notification_text: 'Place hidden',
      business_switch_inactive_error_notification_text: 'Cannot hide place',
      warning_free_limit:
        'You’ve reached the places limit for your current subscription tier. Upgrade to the Pro tier to keep creating unlimited places',
    },
    business_details_section: {
      button_label_back: 'Back',
      button_label_modify: 'Edit place',
      button_label_delete: 'Delete place',
      button_label_disable: 'Hide place',
      button_label_enable: 'Publish place',
      button_label_save: 'Save',
      button_label_cancel: 'Cancel',
      name_label: 'Name',
      address_label: 'Address',
      description_label: 'Description',
      hours_label: 'Hours',
      services_label: 'Services',
      delete_business_dialog_text: 'Do you want to delete {{name}}?',
      delete_business_cancel_btn_label: 'Yes, delete it',
      delete_business_confirm_btn_label: 'Cancel',
      business_deleted_notification_text: 'Place deleted',
      busness_delete_error_notification_text: 'Cannot delete place',
      disable_business_dialog_text: 'Do you want to hide {{name}}?',
      disable_business_cancel_btn_label: 'Cancel',
      disable_business_confirm_btn_label: 'Yes, hide it',
      business_disabled_notification_text: 'Place hidden',
      business_disable_error_notification_text: 'Cannot hide place',
      enable_business_dialog_text: 'Do you want to publish {{name}}?',
      enable_business_cancel_btn_label: 'Cancel',
      enable_business_confirm_btn_label: 'Yes, publish it',
      business_enabled_notification_text: 'Place published',
      business_enable_error_notification_text: 'Cannot publish place',
      business_switched_active_notification_text: 'Place enabled',
      business_switch_active_error_notification_text: 'Cannot enable place',
      business_switched_inactive_notification_text: 'Place hidden',
      business_switch_inactive_error_notification_text: 'Cannot hide place',
      validation_step_service_error_name_required: 'Name is required',
      validation_step_service_error_name_short: 'Name too short!',
      validation_step_service_error_name_long: 'Name too long!',
      validation_step_service_error_description_required:
        'Description is required',
      validation_step_service_error_description_short: 'Description too short!',
      validation_step_service_error_description_long: 'Description too long!',
      business_updated_notification_text: 'Business updated',
      business_update_error_notification_text: 'Cannot update business',
      no_services_label: 'The place is not associated with a service',
    },
    temp_hours_section: {
      closing_hour_label: 'Closed',
      opening_hour_label: 'Open',
      add_temp_hour_btn_label: 'Add temporary closing',
      active_section_title: 'Active temporary closings',
      future_section_title: 'Upcoming temporary closings',
      modal_step_new_temp_hour_heading_title: 'Select a day',
      confirm_delete_temp_hour_text: 'Do you want to delete this hour?',
      confirm_delete_temp_hour_cancel_label: 'Cancel',
      confirm_delete_temp_hour_confirm_label: 'Yes, delete it',
      modal_title: 'New temporary closing',
      modal_submit_btn_label: 'Save',
      modal_cancel_btn_label: 'Close',
      modal_next_btn_label: 'Next',
      modal_back_btn_label: 'Back',
      modal_skip_btn_label: 'Skip',
      modal_step_type_heading_title:
        'What type of temporary hour do you want to add?',
      modal_step_type_heading_subtitle:
        'Select what type of temporary hour you want to add',
      new_temp_hour_closing_hour_label: 'Temporary closing',
      new_temp_hour_opening_hour_label: 'Temporary opening',
      modal_step_period_start_heading_title:
        'When does the temporary hour start?',
      modal_step_period_start_heading_subtitle: 'Set starting date and time',
      modal_step_period_start_select_time_title: 'Select time',
      modal_step_period_end_heading_title: 'When does the temporary hour end?',
      modal_step_period_end_heading_subtitle: 'Set ending date and time',
      modal_step_period_end_select_time_title: 'Select time',
      notes_placeholder: 'Add notes',
      summary_temp_hour_type_label: 'Type',
      summary_temp_hour_start_time_label: 'Start',
      summary_temp_hour_end_time_label: 'End',
      summary_temp_hour_notes_label: 'Notes',
      summary_temp_hour_businesses_label: 'Places',
      summary_temp_hour_services_label: 'Services',
      modal_step_business_selection_heading_title:
        'Which places do you want to apply it to?',
      modal_step_business_selection_heading_subtitle:
        'Select where you want the temporary hour to take effect',
      modal_step_service_selection_heading_title:
        'Which services do you want to apply it to?',
      modal_step_service_selection_heading_subtitle:
        'Select which services you want the temporary hour to affect',
      modal_step_business_selection_applies_to_all: 'All places',
      modal_step_business_selection_applies_to_selection: 'Selected places',
      modal_step_service_selection_applies_to_all: 'All services',
      modal_step_service_selection_applies_to_selection: 'Selected services',
      no_active_hours_found_label: 'No active temporary hour',
      no_future_hours_found_label: 'No upcoming temporary hour',
      delete_success_message: 'Hour deleted',
      delete_failure_message: 'Cannot delete hour',
      create_success_message: 'Hour created',
      create_failure_message: 'Cannot create hour',
      temp_hour_text_template_closed_interval: 'On {{starts}} until {{ends}}',
      temp_hour_text_template_open_interval: 'On {{starts}}',
      temp_hour_text_template_businesses_label: 'Places:',
      temp_hour_text_template_services_label: 'Services:',
      temp_hour_text_template_notes_label: 'Notes:',
    },
    charts_section: {
      total_clients_summary_title_label: 'Treated Patients',
      total_clients_summary_default_period_label: 'Last 12 months',
      total_clients_summary_previous_period_label: 'Previous month: {{amount}}',
      total_appointments_summary_title_label: 'Appointments',
      total_appointments_summary_default_period_label: 'This month',
      total_appointments_summary_previous_period_label:
        'Previous month: {{amount}}',
      total_revenues_summary_title_label: 'Total Revenue',
      total_revenues_summary_default_period_label: 'This month',
      total_revenues_summary_previous_period_label:
        'Previous month: {{amount}}',
      clients_chart_title_label: 'New Patients',
      clients_chart_default_period_label: 'Last 12 months',
      revenues_chart_title_label: 'Revenue',
      revenues_chart_default_period_label: 'Last 12 months',
      services_chart_title_label: 'Appointments',
      services_chart_default_period_label: 'Last 12 months',
      services_chart_column_group_label_value: 'Completed',
      services_chart_column_group_label_value_b: 'Canceled',
      services_chart_column_group_label_value_c: 'Rescheduled',
      services_chart_column_group_tooltip_value: 'Completed: {{amount}}',
      services_chart_column_group_tooltip_value_b: 'Canceled: {{amount}}',
      services_chart_column_group_tooltip_value_c: 'Rescheduled: {{amount}}',
      profile_chart_title_label: 'Profile Views',
      profile_chart_default_period_label: 'Last 30 days',
      contact_appointments_week_distribution_chart_title: 'Preferred Days',
      contact_appointments_hour_distribution_chart_title: 'Preferred Hours',
      contact_appointments_pie_chart_title: 'Appointments',
      contact_appointments_week_distribution_chart_column_group_label_completed:
        'Completed',
      contact_appointments_week_distribution_chart_column_group_label_canceled:
        'Canceled',
      contact_appointments_week_distribution_chart_column_group_label_moved:
        'Rescheduled',
      contact_appointments_hour_distribution_chart_column_group_label_completed:
        'Completed',
      contact_appointments_hour_distribution_chart_column_group_label_canceled:
        'Canceled',
      contact_appointments_hour_distribution_chart_column_group_label_moved:
        'Rescheduled',
      contact_appointments_pie_chart_column_group_label_completed: 'Completed',
      contact_appointments_pie_chart_column_group_label_canceled: 'Canceled',
      contact_appointments_pie_chart_column_group_label_moved: 'Rescheduled',
      contact_appointments_week_distribution_chart_column_group_tooltip_value:
        'Completed: {{amount}}',
      contact_appointments_week_distribution_chart_column_group_tooltip_value_b:
        'Canceled: {{amount}}',
      contact_appointments_week_distribution_chart_column_group_tooltip_value_c:
        'Rescheduled: {{amount}}',
      contact_appointments_hour_distribution_chart_column_group_tooltip_value:
        'Completed: {{amount}}',
      contact_appointments_hour_distribution_chart_column_group_tooltip_value_b:
        'Canceled: {{amount}}',
      contact_appointments_hour_distribution_chart_column_group_tooltip_value_c:
        'Rescheduled: {{amount}}',
      balance_chart_info_description:
        'The chart illustrates the revenue trend over the past 12 months. The horizontal axis represents the months, while the vertical axis shows the revenue values in monetary units. Overall, the chart suggests a growth/decline/stability in revenue during the analyzed period.',
      profile_chart_info_description:
        'The chart illustrates the trend of profile page views over the past 30 days. The horizontal axis represents the days, while the vertical axis shows the number of views. Overall, the chart suggests a growth/decline/stability in profile interest during the analyzed period.',
      clients_chart_info_description:
        'The bar chart displays the number of new patients acquired each month over the past 12 months. The horizontal axis represents the months, while the vertical axis indicates the number of new patients. Each bar reflects the number of new patients for the corresponding month. The chart highlights growth/decline/stability over time, providing a clear overview of patient acquisition during the analyzed period.',
      services_chart_info_description:
        'The bar chart displays the monthly distribution of completed, canceled, and rescheduled appointments over the past 12 months. The horizontal axis represents the months, while the vertical axis shows the number of appointments. Each month is divided into three categories: completed, canceled, and rescheduled, each represented by a different color. The chart allows for the identification of trends and variations over time, such as periods with more completed appointments or an increase in cancellations during specific months. This visualization helps assess appointment management efficiency and detect potential seasonal or operational patterns.',
      balance_summary_info_description:
        'The widget displays the total revenue for the last month as a single numeric value with currency, providing an instant overview of the most recent earnings. Below the main figure, a line chart without axes represents the revenue trend over the past 12 months, allowing for quick trend recognition. Additionally, a label highlights the percentage change compared to the previous month, indicating whether revenue has increased or decreased. This widget offers a clear and immediate financial snapshot, making it useful for tracking growth or identifying potential declines.',
      services_summary_info_description:
        'The widget displays the total number of completed and confirmed appointments for the last month as a single numeric value, providing an instant overview of recent activity. Below the main figure, a line chart without axes represents the appointment trends over the past 12 months, allowing for quick trend analysis. Additionally, a label highlights the percentage difference compared to the previous month, indicating whether the number of appointments has increased or decreased. This widget offers a clear and practical summary for tracking appointment management effectiveness over time.',
      clients_summary_info_description:
        'The widget displays the total number of new patients acquired in the last 12 months as a single numeric value, providing a clear indication of patient base growth. Below the main figure, a line chart without axes represents the cumulative trend of total managed patients over the last 12 months, offering a visual overview of overall growth. Additionally, a label highlights the percentage change in new patient acquisitions compared to the previous month, making trend monitoring easy. This widget helps assess the effectiveness of patient acquisition and retention strategies.',
    },
  },
  notifications: {
    appointment_reminder_whatsapp:
      'Hi {{name}}, just a friendly reminder that you have an upcoming appointment {{time}} for {{service}} at {{address}}',
    appointment_reminder_sms:
      'Hi {{name}}, just a friendly reminder that you have an upcoming appointment {{time}} for {{service}} at {{address}}',
  },
  tags: {
    input_placeholder: 'Category',
    search_placeholder: 'Search',
    'fc98021d-2126-4e28-a1f3-f660792a6577': 'general practitioner',
    '27011e17-e816-4156-857a-b979802d7fc6': 'gynecologist',
    'a7744666-cf26-47c6-a184-0cf6a45cf18b': 'orthopedic',
    '709c8f17-33c2-409d-af3a-a728700a723d': 'dermatologist',
    '4825b1fe-7aa3-4ada-8ba2-e51246b17b40': 'nutritionist',
    '453245e5-4042-44e2-83ce-07aec219f30a': 'psychologist',
    '2cb6a5da-3419-414c-8e3e-4a078fb07b8f': 'ophthalmologist',
    'cc9949a0-f2b6-4385-b7a6-468d81e6796e': 'urologist',
    'd9e3b950-316b-4793-b303-32a7727acadd': 'otolaryngologist',
    'e1be1b28-989f-4c18-8da8-f407c40b6ee6': 'cardiologist',
    '9dd49009-b52f-46de-8fa1-4dae2e267f30': 'dentist',
    '2f2e5617-31fa-41ca-a4ac-332898631be1': 'general surgeon',
    '34be340d-a8d8-4e62-86ee-5c951f28aa27': 'osteopath',
    '6b7dbe55-9377-40e1-a6fe-5c0dfa5b19ef': 'internist',
    '8609a0dd-22ae-4d48-9fda-4077e8fefae3': 'aesthetic doctor',
    'df6f7c7a-4d67-4b42-8c3c-6ddac9c13cfa': 'endocrinologist',
    'cf4bb9ee-033b-4ca3-b763-ead769a2d305': 'gastroenterologist',
    '7ac6bced-9786-4e25-a8e9-a13ca2f39afc': 'neurologist',
    '6a3ff33e-92bf-4816-a66a-d9c26bd6d589': 'neurosurgeon',
    'd72e2b5d-54e3-4dfc-9f98-f3fa10596ff1': 'physiotherapist',
    'b1e70abd-ff17-43ae-b225-04dc5b9f65fa': 'plastic surgeon',
    '579cf9ee-d205-464d-bbbf-b796bb5e4f41': 'psychiatrist',
    'db593f2b-7aee-44f4-8274-c3ab11459ebd': 'psychotherapist',
    '4ea35462-7693-4b4c-83c3-46f6c110098b': 'pediatrician',
    'eb935e4b-307f-4745-a9a6-c23083dd9be1': 'podiatrist',
    'df6c69ce-69ba-463c-b35d-bce63a5cd401': 'rheumatologist',
    'c740313b-1833-40d0-baa7-11bb80350768': 'pulmonologist',
    '800127f6-71b4-45e1-a9d8-d0eb4201d2ce': 'physiatrist',
    'b5971770-c370-4491-adbb-ad2e48da4375': 'vascular surgeon',
    '164b1292-ab49-4de6-8e02-ae9038a4e3c1': 'dietician',
    '1529048c-2b86-4952-a5a1-2d54affb8378': 'andrologist',
    'dc3b7738-47b2-4dd9-ab6a-d131b78e6563': 'allergist',
    'd313374b-6fcd-40e6-9d55-8de81d21d6c7': 'radiologist',
    '62dcc7fc-1d0b-410d-b839-704daee8cc7b': 'proctologist',
    '0e98257d-0611-43cd-9bb7-b0aac7f94440': 'angiologist',
    'c06f7c71-a179-4228-9277-bbc5ecfb2937': 'hematologist',
    'c12b1a38-ab03-4ce3-99e9-ff2c4046eac0': 'breast specialist',
    '78776e61-1431-454b-b1a2-e7de3938d782': 'dietician',
    '2b03c910-9ddc-4662-adfa-75dead4af6e2': 'geriatrician',
    '419afb2f-77f3-437c-83be-1f333025b831': 'sports doctor',
    'bad22744-6c18-4db4-a15f-2ae2a403490b': 'acupuncturist',
    'fabd20be-442a-4f9a-b983-465e283f2ea0': 'oncologist',
    '71ef4a5d-b588-4060-87d8-20166fd132e0': 'private pediatrician',
    'f8040d12-52d1-44a4-b65e-432c9aebe67a': 'clinical psychologist',
    '3fd32fbb-099d-4120-940e-792f4ee3b8e0': 'surgeon',
    'a3fda5c9-5668-494e-9a18-1762d9aeea57': 'nephrologist',
    '9457845b-e0c9-48fb-9cdc-c3aa40d913b4': 'diabetologist',
    'ba743591-56f8-41b0-9602-822cd8dff0eb': 'speech therapist',
    '97253da4-77e3-4354-ac71-04a51d16fda4': 'chiropractor',
    'cb302c5f-fe00-440e-8afe-d5ca5e5ad48d': 'heart surgeon',
    '7d7752d1-daca-4b5c-ac8f-81f8cc0eecb5': 'maxillofacial surgeon',
    '681fb012-f374-494e-8a37-4b4469a7207d': 'coroner',
    '926bf970-3f03-413f-92c4-0b71d70fa1fb': 'orthodontist',
    'd573d25e-a42f-4be3-85f5-7b25605aa233': 'child neuropsychiatrist',
    '695a9ca0-ac93-40a6-9848-9ceb5e9bbffc': 'cosmetic surgeon',
    '919404e9-7505-47a2-867a-7cd8513b4a6e': 'anesthetist',
    '7df670ee-cfcc-4721-add4-a1b8ba65376f': 'pain therapist',
    '8f580c04-637c-4008-b826-829238447844': 'midwife',
    'b44280e2-6831-437d-b585-d71c50b21b66': 'occupational physician',
    '40bbeec3-a295-4215-aef0-dd7f59fb32aa': 'homeopath',
    '546edd8d-663f-4383-bf35-96f08ac8ef3e': 'infectologist',
    '15b82434-ad69-410c-88e2-e80c5ecee21d': 'sexologist',
    '52cd5554-3a2e-46ca-a2ed-eb2f08c71f8d': 'hepatologist',
    'fa3cc123-c2f1-4cce-a226-b93f4c67450d': 'sonographer',
    '0182c98a-ab48-4266-9df7-f1bad76413a3': 'thoracic surgeon',
    '033e2c17-f567-42fe-8190-d9f10e63e739': 'diagnostic radiologist',
    '6bef4f14-cac3-49c6-832e-352d975f3939': 'pediatric surgeon',
    'f5d7c768-74f0-4fe9-a21f-7dcc95a76f1c': 'massage physiotherapist',
    '698481a4-2cb6-4731-8f85-fbbc0582d264': 'orthoptist',
    '199bc0dc-2f84-43a6-b623-5964f2148010': 'spinal surgeon',
    '8e5ad442-edc1-4e4f-aedd-70f6d000669e': 'posturologist',
    'baf7cc2c-5bd2-4096-ad3b-ec8cc816e9c1': 'health technician',
    '7f51bf1a-cbd4-4231-855d-ee31047c3ef5': 'therapist',
    'f70256ae-5649-4078-9270-7ada891049d3': 'phoniatrician',
    'cdc312d7-ca96-4db7-9e2a-9b2dff859721': 'trichologist',
    'e3203ddf-e0c2-4c87-90a3-e7eb6d4b9194': 'professional counselor',
    '239d39fe-ed74-4928-a1ae-ae979986fefb': 'immunologist',
    'ab882720-6eaa-4c58-b919-77e085b17161': 'dental hygienist',
    '83020675-9a8a-4cd1-8ce4-76dac907df16': 'certifying doctor',
    '44ccc6ea-23e1-491f-be43-365772ad3965': 'geneticist doctor',
    '379473b8-ea34-47ba-9eff-34f254192e99': 'neuropsychologist',
    '81fe6ea6-3f83-4014-9033-28ab73f3519d': 'reproductive biologist',
    'e8236f95-d4b7-4400-8c45-7581d1c62ee8': 'anatomopathologist',
    '153d6c3b-8339-467a-9df2-101d1e855205': 'radiotherapist',
    '832aab8c-8f53-4d11-804a-b1bfa6393625': 'nuclear medicine specialist',
    '0fbaf87b-8034-48ab-96e5-4a1c5794bb40': 'nurse',
    '67505de6-e755-40fa-8495-302b7c05b237': 'kinesiologist',
    '16bb3bac-89c5-40bc-8f3d-73d8ce179304': 'blood donation',
    '33458c57-040b-4feb-bb70-466dc06b22ca': 'stomatologist',
    'ed6d2ab6-5460-4dee-97de-66353921ffd4': 'radiology technician',
    'b8cfa3c5-b208-49b0-818a-d5eedac11966': 'clinical analyst',
    '20e56c93-efa8-46de-87f2-086714c3108d': 'audiologist',
    'bc23b5ec-c8ba-4671-aff2-fe3edbbece3f': 'epidemiologist',
    '3150a19f-e2f7-4629-a3eb-0a50640367fc': 'venereologist',
    'c422cf13-79da-4397-92c6-ee0358eee66d': 'dental technician',
  },
  cancel_reason_template: {
    'dc138457-ffc3-41c7-a07a-276c9c2b4df7':
      'The patient asked to cancel the appointment',
    '8b7bb270-1e52-4be3-8623-befc564cd7bb': 'No show',
    'dba1450b-a4bf-4753-8921-77c60ec085be': 'Added by mistake by patient',
    '1f2b387c-28b0-49ab-b2b4-65a6e715df02': 'Other',
    'd9c61337-b226-47f5-9457-c41dd7c3c3b6': 'Do not historicize',
  },
  payment_method_template: {
    'a9355e72-b05b-4fea-b19b-ebc05e1677a3': 'Other',
    'b7543c2a-15c0-434a-8922-a38a0712e19d': 'Do not historicize',
    '3e5a7ce4-3266-496b-828b-f9c2be20c8c0': 'Credit card',
    'dadb749e-8cfc-4b31-9a6f-e6c364ddb196': 'Cash',
    '2b68f512-ad20-4e2c-b440-855d956a965d': 'Due',
  },
  onclickpage: {
    unsubscribe_success_message_title: 'You will be missed',
    unsubscribe_success_message_description:
      'You have been unsubscribed from the {{name}} email notifications list',
    unsubscribe_email_failure_message: 'Cannot complete yout request',
  },
  seo: {
    partner_profile_page_description:
      'Works {{cities}}. Currently open on {{open_days}}.{{service}} Book an appointment now!',
    cookie_page_title:
      'Cookie Policy | Learn How We Use Cookies on {{service}}',
    cookie_page_description:
      'Read our Cookie Policy to learn about the cookies we use, why we use them, and how you can manage your preferences for a safe and personalized browsing experience.',
    privacy_page_title:
      'Privacy Policy | Learn How We Protect Your Data on {{service}}',
    privacy_page_description:
      'Read our Privacy Policy to understand how we collect, use, and protect your personal data in compliance with current regulations.',
    terms_page_title: 'Terms of Service | Rules for Using {{service}}',
    terms_page_description:
      'Read our Terms of Service to understand the rules, rights, and responsibilities of users on {{service}}.',
  },
};

export default locale;
